import { useEffect, useRef, useState } from "react";

const useShouldDisplayCommandStatus = (
  timeout,
  commandResponse,
  commandPending
) => {
  const timeoutRef = useRef(null);
  const [shouldDisplayCommandStatus, displayCommandStatus] = useState(false);

  useEffect(() => {
    if (commandPending) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    } else if (commandResponse) {
      displayCommandStatus(true);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        displayCommandStatus(false);
        timeoutRef.current = null;
      }, timeout);
    } else {
      displayCommandStatus(false);
    }
  }, [commandResponse, commandPending, timeout]);

  return shouldDisplayCommandStatus;
};

export default useShouldDisplayCommandStatus;
